import React from 'react';
import {Empty, NavBar} from 'antd-mobile';
import {t} from "../i18n";

interface EmptyStateProps {
  description?: string;
  imageWidth?: number;
}

const EmptyState: React.FC<EmptyStateProps> = ({
  description = t('pages.noOrderInfo'),
  imageWidth = 128
}) => {
  return (
    <div className="flex flex-col h-screen">
        <div className="flex-1 flex items-center justify-center">
            <Empty
                description={description}
                imageStyle={{ width: imageWidth }}
            />
        </div>
    </div>
  );
};

export default EmptyState;